module.exports = __webpack_public_path__ + "img/light-logo.b9925a50.png";